import axios from "axios";
import config from "../../constants/config";

const url = config.API_URL + '/game/allLeaguesNames';
const url1 = config.API_URL + '/admin/leagueNames';
const url2 = config.API_URL + '/admin/activeLeague';
const url3=config.API_URL +"/admin/league/";
const url4 = config.API_URL + '/game/subleagues';
const url5 = config.API_URL + '/admin/subleagues/upload';
const url6 = config.API_URL + '/admin/subleagues/teams';
const url7 = config.API_URL + '/admin/subleagues/drop';

export const getAllLeagues = async (token) => {
    console.log('called getAllLeagues Method');

    return await axios.get(url, {
      headers: {
        Authorization: token, // Correct placement of Authorization header
        'Content-Type': 'application/json', // Ensure content type is set to JSON
      }
    });
  };

  export const createLeague = async (token,leagueName,imageUrl,isActive,inActiveImage,type) => {
    console.log('called createLeague Method');

    return await axios.post(url1,
      {
        name:leagueName,
        imageUrl: imageUrl,
        isActive: isActive,
        inactiveImageUrl:inActiveImage,
        type
    }, {
      headers: {
        Authorization: token, // Correct placement of Authorization header
        'Content-Type': 'application/json', // Ensure content type is set to JSON
      }
    });
  };

  export const getLeagues = async (token) => {
    console.log('called getLeagues Method');

    return await axios.get(url1, {
      headers: {
        Authorization: token, // Correct placement of Authorization header
        'Content-Type': 'application/json', // Ensure content type is set to JSON
      }
    });
  };

  export const getNcaafSubLeagues = async (token) => {
    console.log('called getNcaafSubLeagues Method');

    return await axios.get(url4, {
      headers: {
        Authorization: token, // Correct placement of Authorization header
        'Content-Type': 'application/json', // Ensure content type is set to JSON
      }
    });
  };


  export const uploadNcaafSubLeaguesExcel = async (file, token) => {
    console.log("called uploadNcaafSubLeaguesExcel Method");
  
    const formData = new FormData();
    formData.append("file", file);
  
    return await axios.post(url5, formData, {
      headers: {
        Authorization: token,
        "Content-Type": "multipart/form-data",
      },
    });
  };

  export const getTeamsByConference = async (token,conference,
    subdivision,
    ) => {
    console.log("called getTeamsByConference Method");
    return await axios.get(url6,
      {
        params: {
          conference,
          subdivision,
        },
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );
  };
  
  export const deleteAllSubLeagues = async (token) => {
    console.log('called deleteAllSubLeagues Method',token);

    return await axios.delete(url7,
       {
      headers: {
        Authorization: token,
        'Content-Type': 'application/json', 
      }
    });
  };



  export const updateLeague = async (token,leagueName,imageUrl,isActive,leagueID,inActiveImage,type) => {
    console.log('called updateLeague Method');

    return await axios.put(url1,
      {
        id:leagueID,
        updateData:{
          imageUrl: imageUrl,
          name:leagueName,
          isActive: isActive,
          inactiveImageUrl:inActiveImage,
          type
        }
      
    }, {
      headers: {
        Authorization: token, // Correct placement of Authorization header
        'Content-Type': 'application/json', // Ensure content type is set to JSON
      }
    });
  };

  export const activateLeague = async (token,leagueId,isActive) => {
    console.log('called activateLeague Method',leagueId,isActive);

    return await axios.put(url2,
      {
        leagueId: leagueId,
        isActive: isActive
    }, {
      headers: {
        Authorization: token, // Correct placement of Authorization header
        'Content-Type': 'application/json', // Ensure content type is set to JSON
      }
    });
  };


  export const deleteSingleLeague = async (token,leagueId) => {
    console.log('called deleteSingleLeague Method',leagueId);

    return await axios.delete(url3+leagueId,
       {
      headers: {
        Authorization: token, // Correct placement of Authorization header
        'Content-Type': 'application/json', // Ensure content type is set to JSON
      }
    });
  };